// import React, { useEffect, useState } from 'react';
// import { useNavigate } from 'react-router-dom';
// import { getFlowerImages, createLetterToHeaven, updateLetterToHeaven } from '../api';
// import { saveLetterData, getUserIPAddress } from '../utils/profilePhotoUtils';
// import '../styles/LetterToHeavenWritingMobile.css';

// const normalizeFlowers = (raw) => {

//   const arr = Array.isArray(raw) ? raw : (Array.isArray(raw?.content) ? raw.content : (Array.isArray(raw?.data) ? raw.data : []));
//   return arr.map(f => ({
//     flowerId: Number(f.flowerId ?? f.id ?? f.flower_id ?? 0),
//     imageUrl: f.imageUrl ?? f.url ?? f.image ?? f.path ?? f.src ?? f.image_url ?? '',
//     name: f.name ?? ''
//   })).filter(x => x.flowerId && x.imageUrl);
// };

// const LetterToHeavenWritingMobile = () => {
//   const navigate = useNavigate();

//   // form
//   const [recipient, setRecipient] = useState('');
//   const [sender, setSender] = useState('');
//   const [password, setPassword] = useState('');
//   const [title, setTitle] = useState('');
//   const [content, setContent] = useState('');

//   // edit mode
//   const [isEditMode, setIsEditMode] = useState(false);
//   const [editingLetterId, setEditingLetterId] = useState(null);

//   // flowers from API
//   const [flowers, setFlowers] = useState([]); // [{flowerId, imageUrl, name}]
//   const [loadingFlowers, setLoadingFlowers] = useState(true);
//   const [flowerLoadError, setFlowerLoadError] = useState(null);

//   // selected flower (the important part)
//   const [selectedFlowerId, setSelectedFlowerId] = useState(null);   // numeric flowerId
//   const [selectedFlowerUrl, setSelectedFlowerUrl] = useState('');   // its URL (for saving/display)


//   const [selectedStamp, setSelectedStamp] = useState('stamp-1');


//   useEffect(() => {
//     let editingData = localStorage.getItem('editingLetterToHeavenData') || localStorage.getItem('editingLetterToHeavenDataPC');
//     if (!editingData) return;
//     try {
//       const parsed = JSON.parse(editingData);
//       setRecipient(parsed.recipient || '');
//       setSender(parsed.sender || '');
//       setPassword(parsed.password || '');
//       setTitle(parsed.title || '');
//       setContent(parsed.content || '');
//       setSelectedStamp(parsed.selectedStamp || 'stamp-1');
//       setEditingLetterId(parsed.id ?? null);
//       if (parsed.selectedFlowerId) {
//         setSelectedFlowerId(parsed.selectedFlowerId);
//         setSelectedFlowerUrl(parsed.selectedFlowerUrl || '');
//       } else if (parsed.boardStamp || parsed.board_stamp) {
//         setSelectedFlowerId(parsed.boardStamp ?? parsed.board_stamp);
//       }
//       setIsEditMode(Boolean(parsed.id));
//     } catch (err) {
//       console.error('Error parsing editing draft:', err);
//     }
//   }, []);

//   // load flowers from API and pick default selection
//   useEffect(() => {
//     let mounted = true;
//     const load = async () => {
//       try {
//         setLoadingFlowers(true);
//         const res = await getFlowerImages(); // your apiClient endpoint: /api/v1/letter/flower-images
//         const list = normalizeFlowers(res?.data ?? res);
//         if (!mounted) return;
//         if (!list.length) throw new Error('No flower images returned');
//         setFlowers(list);


//         // priority: already selectedFlowerId (draft) -> legacy selectedStamp (stamp-X) -> first flower
//         if (selectedFlowerId) {
//           // we already have selection (from draft load), find URL if empty
//           const found = list.find(f => Number(f.flowerId) === Number(selectedFlowerId));
//           if (found && !selectedFlowerUrl) setSelectedFlowerUrl(found.imageUrl);
//         } else {
//           // check legacy selectedStamp like 'stamp-3' (older drafts)
//           if (/^stamp-\d+$/.test(selectedStamp)) {
//             const num = parseInt(selectedStamp.replace('stamp-', ''), 10);
//             // try to find by matching flowerId == num or pick the nth item (1-index)
//             const byId = list.find(f => Number(f.flowerId) === num);
//             const byIndex = list[num - 1];
//             const pick = byId || byIndex || list[0];
//             setSelectedFlowerId(pick.flowerId);
//             setSelectedFlowerUrl(pick.imageUrl);
//             setSelectedStamp(`stamp-${pick.flowerId}`);
//           } else {
//             // default to first
//             setSelectedFlowerId(list[0].flowerId);
//             setSelectedFlowerUrl(list[0].imageUrl);
//             setSelectedStamp(`stamp-${list[0].flowerId}`);
//           }
//         }
//       } catch (err) {
//         console.error('Failed to load flower images:', err);
//         setFlowerLoadError(err?.message || 'Failed to load');
//         // fallback static list so UI still works
//         const fallback = [
//           { flowerId: 1, imageUrl: '/heaven/getty-images-145244798.png' },
//           { flowerId: 2, imageUrl: '/heaven/getty-images-465710299.png' },
//           { flowerId: 3, imageUrl: '/heaven/getty-images-955651052.png' },
//           { flowerId: 4, imageUrl: '/heaven/getty-images-907936742.png' },
//           { flowerId: 5, imageUrl: '/heaven/getty-images-494124656.png' },
//           { flowerId: 6, imageUrl: '/heaven/getty-images-926601494.png' },
//           { flowerId: 7, imageUrl: '/heaven/getty-images-537807854.png' }
//         ];
//         if (!mounted) return;
//         setFlowers(fallback);
//         setSelectedFlowerId(fallback[0].flowerId);
//         setSelectedFlowerUrl(fallback[0].imageUrl);
//         setSelectedStamp(`stamp-${fallback[0].flowerId}`);
//       } finally {
//         if (mounted) setLoadingFlowers(false);
//       }
//     };

//     load();
//     return () => { mounted = false; };

//   }, []); 

//   const handleSelectFlower = (flower) => {
//     setSelectedFlowerId(flower.flowerId);
//     setSelectedFlowerUrl(flower.imageUrl);
//     setSelectedStamp(`stamp-${flower.flowerId}`); 
//   };

//   const saveLetterDataToAPI = async () => {
//     // Basic validation (you can expand)
//     if (!recipient.trim() || !sender.trim() || !password.trim() || !title.trim() || !content.trim()) {
//       alert('모든 필수 항목을 입력해주세요.');
//       return;
//     }

//     try {
//       const ip = await getUserIPAddress();
//       const payload = {
//         title,
//         content,
//         password,
//         secureFlag: 'Y',
//         ip,
//         userName: sender,
//         toName: recipient,
//         // THE FIX: send the real flowerId as board_stamp
//         board_stamp: selectedFlowerId ?? 0,
//         // send both just in case backend expects either format
//         boardStamp: selectedFlowerId ?? 0,
//         flowerImageUrl: selectedFlowerUrl ?? ''
//       };

//       let res;
//       if (isEditMode && editingLetterId) {
//         const updatePayload = { id: editingLetterId, ...payload };
//         console.log('Updating letter with payload', updatePayload);
//         res = await updateLetterToHeaven(updatePayload);
//       } else {
//         console.log('Creating letter with payload', payload);
//         res = await createLetterToHeaven(payload);
//       }

//       // Save to localStorage for cross-platform sync (keep legacy and new fields)
//       const localObj = {
//         recipient,
//         sender,
//         password,
//         title,
//         content,
//         selectedStamp,             // legacy
//         selectedFlowerId,          // new
//         selectedFlowerUrl,         // new
//         boardStamp: selectedFlowerId,
//         date: new Date().toLocaleDateString('ko-KR', { year: 'numeric', month: '2-digit', day: '2-digit' }).replace(/\. /g, '.').replace(/\.$/, ''),
//         id: isEditMode ? editingLetterId : (res?.data?.id ?? res?.data?.letterId ?? Date.now())
//       };
//       saveLetterData(localObj, 'Mobile');

//       // Clear editing keys if any
//       if (isEditMode) {
//         localStorage.removeItem('editingLetterToHeavenData');
//         localStorage.removeItem('selectedLetterToHeavenData');
//       }


//       navigate('/letter-to-heaven-board-list');
//     } catch (err) {
//       console.error('Failed saving letter:', err);
//       // fallback to localStorage only
//       const fallback = {
//         recipient, sender, password, title, content,
//         selectedStamp, selectedFlowerId, selectedFlowerUrl,
//         boardStamp: selectedFlowerId,
//         date: new Date().toISOString().split('T')[0],
//         id: isEditMode ? editingLetterId : Date.now()
//       };
//       saveLetterData(fallback, 'Mobile');
//       navigate('/letter-to-heaven-board-list');
//     }
//   };

//   const handleCancel = () => {
//     // clear edit draft if exist
//     if (isEditMode) {
//       localStorage.removeItem('editingLetterToHeavenData');
//       localStorage.removeItem('selectedLetterToHeavenData');
//     }
//     navigate('/letter-to-heaven-board-list');
//   };

//   return (   
//        <div className="letter-to-heaven-board-list-mobile-unique announcement-list-page donate-info-page-pc">
//       <FamilyPlazaTopSection />


//        <main className="main-content">
//         <FamilyPlazaSubHeading heading="사이버추모관" />

//       {/* Header / dropdown - kept as original structure */}
//       <div className="letter-to-heaven-writing-mobile-dropdown-section-unique">
//         <div className="letter-to-heaven-writing-mobile-dropdown-container-unique">
//           <div className="letter-to-heaven-writing-mobile-dropdown-header-unique">
//             <div className="letter-to-heaven-writing-mobile-title-wrapper-unique">
//               <div className="letter-to-heaven-writing-mobile-title-decorator-unique"></div>
//               <h2 className="letter-to-heaven-writing-mobile-section-title-unique">{isEditMode ? '하늘로 보내는 편지 수정' : '하늘로 보내는 편지'}</h2>
//             </div>
//           </div>
//         </div>
//       </div>

//       {/* Form */}
//       <div className="letter-to-heaven-writing-mobile-form-section-unique">
//         <div className="letter-to-heaven-writing-mobile-form-container-unique">

//           {/* Recipient */}
//           <div className="letter-to-heaven-writing-mobile-form-row-unique">
//             <label className="letter-to-heaven-writing-mobile-form-label-unique">받으시는 분<span className="letter-to-heaven-writing-mobile-asterisk-unique">*</span></label>
//             <input type="text" className="letter-to-heaven-writing-mobile-input-field-unique" value={recipient} onChange={(e) => setRecipient(e.target.value)} />
//           </div>

//           {/* Sender */}
//           <div className="letter-to-heaven-writing-mobile-form-row-unique">
//             <label className="letter-to-heaven-writing-mobile-form-label-unique">보내시는 분<span className="letter-to-heaven-writing-mobile-asterisk-unique">*</span></label>
//             <input type="text" className="letter-to-heaven-writing-mobile-input-field-unique" value={sender} onChange={(e) => setSender(e.target.value)} />
//           </div>

//           {/* Password */}
//           <div className="letter-to-heaven-writing-mobile-form-row-unique">
//             <label className="letter-to-heaven-writing-mobile-form-label-unique">비밀번호<span className="letter-to-heaven-writing-mobile-asterisk-unique">*</span></label>
//             <span className="letter-to-heaven-writing-mobile-password-hint-unique">영문+숫자 10자리 미만</span>
//             <input type="password" className="letter-to-heaven-writing-mobile-input-field-unique" value={password} onChange={(e) => setPassword(e.target.value)} />
//           </div>

//           {/* Flower (stamp) selection */}
//           <div className="letter-to-heaven-writing-mobile-stamp-section-unique">
//             <div className="letter-to-heaven-writing-mobile-stamp-label-unique">우표이미지<span className="letter-to-heaven-writing-mobile-asterisk-unique">*</span></div>
//             <div className="letter-to-heaven-writing-mobile-stamp-options-unique">
//               {loadingFlowers ? (
//                 <div style={{ padding: 8 }}>이미지 로딩 중...</div>
//               ) : (
//                 flowers.map(flower => (
//                   <div key={flower.flowerId} className="letter-to-heaven-writing-mobile-stamp-option-unique">
//                     <label htmlFor={`stamp-${flower.flowerId}`} className="letter-to-heaven-writing-mobile-stamp-option-label-unique">
//                       <img src={flower.imageUrl} alt={flower.name || `Stamp ${flower.flowerId}`} onError={(e) => { e.currentTarget.src = '/images/d1.png'; }} />
//                     </label>
//                     <input
//                       type="radio"
//                       name="stamp-selection"
//                       id={`stamp-${flower.flowerId}`}
//                       className="letter-to-heaven-writing-mobile-stamp-radio-unique"
//                       checked={String(selectedFlowerId) === String(flower.flowerId)}
//                       onChange={() => handleSelectFlower(flower)}
//                     />
//                   </div>
//                 ))
//               )}
//             </div>
//           </div>

//           {/* Title */}
//           <div className="letter-to-heaven-writing-mobile-content-section-unique">
//             <div className="letter-to-heaven-writing-mobile-form-row-unique">
//               <label className="letter-to-heaven-writing-mobile-form-label-unique">제목<span className="letter-to-heaven-writing-mobile-asterisk-unique">*</span></label>
//               <input type="text" className="letter-to-heaven-writing-mobile-input-field-unique" value={title} onChange={(e) => setTitle(e.target.value)} />
//             </div>

//             {/* Content */}
//             <div className="letter-to-heaven-writing-mobile-form-row-unique">
//               <label className="letter-to-heaven-writing-mobile-form-label-unique">내용<span className="letter-to-heaven-writing-mobile-asterisk-unique">*</span></label>
//               <textarea className="letter-to-heaven-writing-mobile-textarea-field-unique" value={content} onChange={(e) => setContent(e.target.value)} rows={6} />
//             </div>

//             {/* Actions */}
//             <div className="letter-to-heaven-writing-mobile-action-buttons-unique">
//               <button className="letter-to-heaven-writing-mobile-register-btn-unique" onClick={saveLetterDataToAPI} disabled={!selectedFlowerId}>{isEditMode ? '수정' : '등록'}</button>
//               <button className="letter-to-heaven-writing-mobile-cancel-btn-unique" onClick={handleCancel}>취소</button>
//             </div>

//             {/* Notice */}
//             <div className="letter-to-heaven-writing-mobile-notice">
//               <p>* 고인을 기억하는 이야기는 누군가에게 큰 위로가 됩니다.</p>
//               <p>본 게시판에 남겨주신 글은 강화 파라다이스 공식 블로그에 소개될 수 있으며,</p>
//               <p>이 경우 성함 등 개인정보는 공개되지 않습니다. 글이 외부에 노출되는 것을 원하지 않으시는 경우, 작성 후 비밀글로 설정해주세요.</p>
//             </div>
//           </div>
//         </div>
//       </div>
//       </main>
//     </div>
//   );
// };

// export default LetterToHeavenWritingMobile;


import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { getFlowerImages, createLetterToHeaven, updateLetterToHeaven } from '../api';
import { saveLetterData, getUserIPAddress } from '../utils/profilePhotoUtils';
import '../styles/LetterToHeavenWritingMobile.css';
import FamilyPlazaSubHeading from './family-plaza/FamilyPlazaSubHeading';
import FamilyPlazaTopSection from './family-plaza/FamilyPlazaTopSection';


const normalizeFlowers = (raw) => {
  const arr = Array.isArray(raw)
    ? raw
    : Array.isArray(raw?.content)
      ? raw.content
      : Array.isArray(raw?.data)
        ? raw.data
        : [];

  return arr
    .map((f, index) => ({
      flowerId: Number(
        f.flowerId ??
        f.boardStampId ??
        f.board_stamp_id ??
        f.board_stamp ??
        f.boardStamp ??
        f.id ??
        f.flower_id ??
        0
      ),
      imageUrl:
        f.imageUrl ?? f.flowerImageUrl ?? f.url ?? f.image ?? f.path ?? f.src ?? f.image_url ?? f.imageUrlPath ?? '',
      name: f.name ?? f.flowerName ?? f.title ?? `Stamp ${index + 1}`,
    }))

    .filter((x) => Boolean(x.flowerId) && Boolean(x.imageUrl));
};

const LetterToHeavenWritingMobile = () => {
  const navigate = useNavigate();

  // form
  const [recipient, setRecipient] = useState('');
  const [sender, setSender] = useState('');
  const [password, setPassword] = useState('');
  const [title, setTitle] = useState('');
  const [content, setContent] = useState('');

  // edit mode
  const [isEditMode, setIsEditMode] = useState(false);
  const [editingLetterId, setEditingLetterId] = useState(null);


  const [flowers, setFlowers] = useState([]);
  const [loadingFlowers, setLoadingFlowers] = useState(true);
  const [flowerLoadError, setFlowerLoadError] = useState(null);


  const [selectedFlowerId, setSelectedFlowerId] = useState(null);
  const [selectedFlowerUrl, setSelectedFlowerUrl] = useState('');

  const [selectedStamp, setSelectedStamp] = useState('stamp-1');


  useEffect(() => {
    let editingData =
      localStorage.getItem('editingLetterToHeavenData') ||
      localStorage.getItem('editingLetterToHeavenDataPC');
    if (!editingData) return;
    try {
      const parsed = JSON.parse(editingData);
      setRecipient(parsed.recipient || '');
      setSender(parsed.sender || '');
      setPassword(parsed.password || '');
      setTitle(parsed.title || '');
      setContent(parsed.content || '');
      setSelectedStamp(parsed.selectedStamp || 'stamp-1');
      setEditingLetterId(parsed.id ?? null);


      if (parsed.selectedFlowerId) {
        setSelectedFlowerId(Number(parsed.selectedFlowerId));
        setSelectedFlowerUrl(parsed.selectedFlowerUrl || '');
      } else if (parsed.boardStamp || parsed.board_stamp || parsed.boardStampId) {

        setSelectedFlowerId(Number(parsed.boardStamp ?? parsed.board_stamp ?? parsed.boardStampId ?? 0));
      }
      setIsEditMode(Boolean(parsed.id));
    } catch (err) {
      console.error('Error parsing editing draft:', err);
    }
  }, []);


  useEffect(() => {
    let mounted = true;
    const load = async () => {
      try {
        setLoadingFlowers(true);
        const res = await getFlowerImages();
        const list = normalizeFlowers(res?.data ?? res);
        if (!mounted) return;

        if (!list.length) throw new Error('No flower images returned');

        setFlowers(list);


        if (selectedFlowerId) {

          const found = list.find((f) => Number(f.flowerId) === Number(selectedFlowerId));
          if (found && !selectedFlowerUrl) setSelectedFlowerUrl(found.imageUrl);
        } else {

          if (/^stamp-\d+$/.test(selectedStamp)) {
            const num = parseInt(selectedStamp.replace('stamp-', ''), 10);

            const byId = list.find((f) => Number(f.flowerId) === num);
            const byIndex = list[num - 1];
            const pick = byId || byIndex || list[0];
            setSelectedFlowerId(pick.flowerId);
            setSelectedFlowerUrl(pick.imageUrl);
            setSelectedStamp(`stamp-${pick.flowerId}`);
          } else {
            // default to first
            setSelectedFlowerId(list[0].flowerId);
            setSelectedFlowerUrl(list[0].imageUrl);
            setSelectedStamp(`stamp-${list[0].flowerId}`);
          }
        }
      } catch (err) {
        console.error('Failed to load flower images:', err);
        setFlowerLoadError(err?.message || 'Failed to load');
        // fallback static list so UI still works
        const fallback = [
          { flowerId: 1, imageUrl: '/heaven/getty-images-145244798.png' },
          { flowerId: 2, imageUrl: '/heaven/getty-images-465710299.png' },
          { flowerId: 3, imageUrl: '/heaven/getty-images-955651052.png' },
          { flowerId: 4, imageUrl: '/heaven/getty-images-907936742.png' },
          { flowerId: 5, imageUrl: '/heaven/getty-images-494124656.png' },
          { flowerId: 6, imageUrl: '/heaven/getty-images-926601494.png' },
          { flowerId: 7, imageUrl: '/heaven/getty-images-537807854.png' },
        ];
        if (!mounted) return;
        setFlowers(fallback);
        setSelectedFlowerId(fallback[0].flowerId);
        setSelectedFlowerUrl(fallback[0].imageUrl);
        setSelectedStamp(`stamp-${fallback[0].flowerId}`);
      } finally {
        if (mounted) setLoadingFlowers(false);
      }
    };

    load();
    return () => {
      mounted = false;
    };

  }, []);

  const handleSelectFlower = (flower) => {
    setSelectedFlowerId(Number(flower.flowerId));
    setSelectedFlowerUrl(flower.imageUrl);
    setSelectedStamp(`stamp-${flower.flowerId}`);
  };

  const saveLetterDataToAPI = async () => {
    // Basic validation (you can expand)
    if (!recipient.trim() || !sender.trim() || !password.trim() || !title.trim() || !content.trim()) {
      alert('모든 필수 항목을 입력해주세요.');
      return;
    }

    try {
      const ip = await getUserIPAddress();


      const payload = {
        title,
        content,
        password,
        secureFlag: 'Y',
        ip,
        userName: sender,
        toName: recipient,
        board_stamp: Number(selectedFlowerId ?? 0),
        boardStamp: Number(selectedFlowerId ?? 0),
        flowerImageUrl: selectedFlowerUrl ?? '',
      };

      let res;
      if (isEditMode && editingLetterId) {
        const updatePayload = { id: editingLetterId, ...payload };
        console.log('Updating letter with payload', updatePayload);
        res = await updateLetterToHeaven(updatePayload);
      } else {
        console.log('Creating letter with payload', payload);
        res = await createLetterToHeaven(payload);
      }


      const localObj = {
        recipient,
        sender,
        password,
        title,
        content,
        selectedStamp, // legacy
        selectedFlowerId, // new
        selectedFlowerUrl, // new
        boardStamp: selectedFlowerId,
        date: new Date().toLocaleDateString('ko-KR', { year: 'numeric', month: '2-digit', day: '2-digit' }).replace(/\. /g, '.').replace(/\.$/, ''),
        id: isEditMode ? editingLetterId : (res?.data?.id ?? res?.data?.letterId ?? Date.now()),
      };
      saveLetterData(localObj, 'Mobile');


      if (isEditMode) {
        localStorage.removeItem('editingLetterToHeavenData');
        localStorage.removeItem('selectedLetterToHeavenData');
      }

      navigate('/letter-to-heaven-board-list');
    } catch (err) {
      console.error('Failed saving letter:', err);
      // fallback to localStorage only
      const fallback = {
        recipient,
        sender,
        password,
        title,
        content,
        selectedStamp,
        selectedFlowerId,
        selectedFlowerUrl,
        boardStamp: selectedFlowerId,
        date: new Date().toISOString().split('T')[0],
        id: isEditMode ? editingLetterId : Date.now(),
      };
      saveLetterData(fallback, 'Mobile');
      navigate('/letter-to-heaven-board-list');
    }
  };

  const handleCancel = () => {

    if (isEditMode) {
      localStorage.removeItem('editingLetterToHeavenData');
      localStorage.removeItem('selectedLetterToHeavenData');
    }
    navigate('/letter-to-heaven-board-list');
  };

  return (

    <div className="letter-to-heaven-board-list-mobile-unique announcement-list-page donate-info-page-pc">
      <FamilyPlazaTopSection />


      <main className="main-content">
        <FamilyPlazaSubHeading heading="하늘로 보내는 편지" />

        {/* Header / dropdown - kept as original structure */}
        {/* <div className="letter-to-heaven-writing-mobile-dropdown-section-unique">
          <div className="letter-to-heaven-writing-mobile-dropdown-container-unique">
            <div className="letter-to-heaven-writing-mobile-dropdown-header-unique">
              <div className="letter-to-heaven-writing-mobile-title-wrapper-unique">
                <div className="letter-to-heaven-writing-mobile-title-decorator-unique"></div>
                <h2 className="letter-to-heaven-writing-mobile-section-title-unique">{isEditMode ? '하늘로 보내는 편지 수정' : '하늘로 보내는 편지'}</h2>
              </div>
            </div>
          </div>
        </div> */}

        {/* Form */}
        <div className="letter-to-heaven-writing-mobile-form-section-unique">
          <div className="letter-to-heaven-writing-mobile-form-container-unique">

            {/* Recipient */}
            <div className="letter-to-heaven-writing-mobile-form-row-unique">
              <label className="letter-to-heaven-writing-mobile-form-label-unique">받으시는 분<span className="letter-to-heaven-writing-mobile-asterisk-unique">*</span></label>
              <input type="text" className="letter-to-heaven-writing-mobile-input-field-unique" value={recipient} onChange={(e) => setRecipient(e.target.value)} />
            </div>

            {/* Sender */}
            <div className="letter-to-heaven-writing-mobile-form-row-unique">
              <label className="letter-to-heaven-writing-mobile-form-label-unique">보내시는 분<span className="letter-to-heaven-writing-mobile-asterisk-unique">*</span></label>
              <input type="text" className="letter-to-heaven-writing-mobile-input-field-unique" value={sender} onChange={(e) => setSender(e.target.value)} />
            </div>

            {/* Password */}
            <div className="letter-to-heaven-writing-mobile-form-row-unique">
              <label className="letter-to-heaven-writing-mobile-form-label-unique">비밀번호<span className="letter-to-heaven-writing-mobile-asterisk-unique">*</span></label>
              <span className="letter-to-heaven-writing-mobile-password-hint-unique">영문+숫자 10자리 미만</span>
              <input type="password" className="letter-to-heaven-writing-mobile-input-field-unique" value={password} onChange={(e) => setPassword(e.target.value)} />
            </div>

            {/* Flower (stamp) selection */}
            <div className="letter-to-heaven-writing-mobile-stamp-section-unique">
              <div className="letter-to-heaven-writing-mobile-stamp-label-unique">우표이미지<span className="letter-to-heaven-writing-mobile-asterisk-unique">*</span></div>
              <div className="letter-to-heaven-writing-mobile-stamp-options-unique">
                {loadingFlowers ? (
                  <div style={{ padding: 8 }}>이미지 로딩 중...</div>
                ) : (
                  flowers.map((flower) => (
                    <div key={flower.flowerId} className="letter-to-heaven-writing-mobile-stamp-option-unique">
                      <label htmlFor={`stamp-${flower.flowerId}`} className="letter-to-heaven-writing-mobile-stamp-option-label-unique">
                        <img
                          src={flower.imageUrl}
                          alt={flower.name || `Stamp ${flower.flowerId}`}
                          onError={(e) => {
                            e.currentTarget.src = '/images/d1.png';
                          }}
                        />
                      </label>
                      <input
                        type="radio"
                        name="stamp-selection"
                        id={`stamp-${flower.flowerId}`}
                        className="letter-to-heaven-writing-mobile-stamp-radio-unique"
                        checked={String(selectedFlowerId) === String(flower.flowerId)}
                        onChange={() => handleSelectFlower(flower)}
                      />
                    </div>
                  ))
                )}
              </div>
            </div>

            {/* Title */}
            <div className="letter-to-heaven-writing-mobile-content-section-unique">
              <div className="letter-to-heaven-writing-mobile-form-row-unique">
                <label className="letter-to-heaven-writing-mobile-form-label-unique">제목<span className="letter-to-heaven-writing-mobile-asterisk-unique">*</span></label>
                <input type="text" className="letter-to-heaven-writing-mobile-input-field-unique" value={title} onChange={(e) => setTitle(e.target.value)} />
              </div>

              {/* Content */}
              <div className="letter-to-heaven-writing-mobile-form-row-unique">
                <label className="letter-to-heaven-writing-mobile-form-label-unique">내용<span className="letter-to-heaven-writing-mobile-asterisk-unique">*</span></label>
                <textarea className="letter-to-heaven-writing-mobile-textarea-field-unique" value={content} onChange={(e) => setContent(e.target.value)} rows={6} />
              </div>

              {/* Actions */}
              <div className="letter-to-heaven-writing-mobile-action-buttons-unique">
                <button className="letter-to-heaven-writing-mobile-register-btn-unique" onClick={saveLetterDataToAPI} disabled={!selectedFlowerId}>{isEditMode ? '수정' : '등록'}</button>
                <button className="letter-to-heaven-writing-mobile-cancel-btn-unique" onClick={handleCancel}>취소</button>
              </div>

              {/* Notice */}
              <div className="letter-to-heaven-writing-mobile-notice">
                <p>* 고인을 기억하는 이야기는 누군가에게 큰 위로가 됩니다.</p>
                <p>본 게시판에 남겨주신 글은 강화 파라다이스 공식 블로그에 소개될 수 있으며,</p>
                <p>이 경우 성함 등 개인정보는 공개되지 않습니다. 글이 외부에 노출되는 것을 원하지 않으시는 경우, 작성 후 비밀글로 설정해주세요.</p>
              </div>
            </div>
          </div>
        </div>
      </main>
    </div>
  );
};

export default LetterToHeavenWritingMobile;



